import React, {useEffect, useContext } from "react";
import {datePhrase, getWeekday} from '../../../../../functions/Functions';
import DatePicker, {CalendarContainer} from "react-datepicker";
import {Errors, GetPremium} from '../../../../../partials/Partials';
import "react-datepicker/dist/react-datepicker.css";
import {LawyerContext} from '../../../../../partials/Context';
import {getDates} from '../../../../../functions/api';

function RespondForm(props) {
    const {id, submitResponse, startDate, handleEarliestDate, handleCurrentDate, currentDate, handleMonthChange, displayedMonth, handleProblemId, handleData, handleChecked, data, handleDataChange, handleStartDate, ifSent, message, errors, setErrors} = props;

    const lawyer = useContext(LawyerContext);
    const {is_premium} = lawyer;

    useEffect(()=> {
            if (id)
            getDates(id, data, handleEarliestDate, handleStartDate, handleData, displayedMonth, setErrors)
            //eslint-disable-next-line react-hooks/exhaustive-deps
        },[displayedMonth])

    useEffect(()=>{
        handleProblemId(id)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    if (is_premium) {        
    if (!ifSent) {
        return(
            <Form 
                lawyer={lawyer}
                data={data}
                handleDataChange={handleDataChange}
                submitResponse={submitResponse}
                handleChecked={handleChecked}
                currentDate={currentDate}
                handleCurrentDate={handleCurrentDate}
                startDate={startDate}
                handleMonthChange={handleMonthChange}
                errors={errors}
            />
        )
    } else {
        return (
            <FormSent
                lawyer={lawyer}
                data={data}
                message={message}
                ifSent={ifSent}
                errors={errors}
            />
        )
    }
} else {
    return (
        <div className='col-sm-6 respondFormContainer'>
            <GetPremium />
        </div> 
    )
}
}
class Form extends React.Component {
    render() {
        const {lawyer, data, handleDataChange, submitResponse, handleChecked, currentDate, handleCurrentDate, startDate, handleMonthChange, ifSent, errors} = this.props
            const {title, user} = lawyer || ''
            const {name} = title || ''
            const {first_name} = user || ''
           
        return(
             <div className='col-sm-6 respondFormContainer'>
                <h1 className="stdHeader text-primary">Twoja odpowiedź</h1>
                <div className="from">
                    Od: {name} <b>{first_name}</b>
                </div>
                <form onSubmit={submitResponse}>
                    <FormInputs 
                        data={data}
                        handleDataChange={handleDataChange}
                        handleChecked={handleChecked}
                        ifSent={ifSent}
                    />
                    <Calendar 
                        currentDate={currentDate}
                        handleCurrentDate={handleCurrentDate}
                        startDate={startDate}
                        handleMonthChange={handleMonthChange}
                    />    
                    <div>
                        Aby ustalić dokładną godzinę spotkania, <b>prosimy o kontakt</b> z naszą kancelarią.
                    </div>
                    <div className="submit-form top-buffer">
                        <input type="submit" value="Wyślij" className="submit-btn"/>
                        <div className='errors-field'>
                            <Errors errors={errors} />
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

class FormInputs extends React.Component {
    render() {
        const {data,handleDataChange, handleChecked, ifSent} = this.props
        let {rate_per_hour, or_per_case, discount} = data
        if (!rate_per_hour) {
            rate_per_hour = '';
        }
        if (!discount) {
            discount = ''
        }
        return(
        <>
            <div>
                Chętnie udzielimy Państwu <b>pomocy</b>.<br/>
                <div className="form-group">
                    Nasza <b>stawka za godzinę</b> wynosi
                    <input 
                        type="text" 
                        name="rate_per_hour" 
                        className="small input" 
                        size="7" 
                        value={rate_per_hour} 
                        onChange={(rate_per_hour)=>handleDataChange(rate_per_hour)}
                    />
                    złotych + 23% VAT
                    <div className="checkbox" >
                        <label htmlFor="or_per_case" className="or_per_case">
                            <input 
                                type="checkbox" 
                                name="or_per_case" 
                                id="or_per_case" 
                                defaultChecked={or_per_case}
                                onClick={()=>handleChecked(or_per_case)}
                            />
                            Proponujemy opłatę całościową "od sprawy":
                        </label>
                    </div>
                </div>
            </div>
            <CasePrice
                data={data} 
                ifSent={ifSent} 
                handleDataChange={handleDataChange}
            />
            <div className="form-group">
                Nowym klientom z serwisu&nbsp;
                <a href="/" className="text-primary">SpecPrawnik.pl </a>
                oferujemy przy pierwszej wizycie <b>rabat w wysokości</b>
                <input 
                    type="text" 
                    name="discount" 
                    className="small input" 
                    size="4" 
                    required={true} 
                    value={discount} 
                    onChange={(discount)=>handleDataChange(discount)}
                />%
            </div>
        </>
        )
    }
}

class Calendar extends React.Component {
    render() {
        const {currentDate, handleCurrentDate, startDate, handleMonthChange} = this.props
        const days = ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.']
        const months = ['Styczeń', 'Luty', 'Marzec', 'Kwiecien', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień']
        const locale = {
            localize: {
                day: n => days[n],
                month: n => months[n]
            },
            formatLong: {
                date: () => 'dd-mm-yyyy'
            }
        }
        const MyContainer = ({ className, children }) => {
            return (
                <div className="datepicker">
                    <CalendarContainer className={className}>
                        <div>{children}</div>
                    </CalendarContainer>
                </div>
            );
        }
        return(
            <div className="preLast form-group">
                <b>Najwcześniejszy termin </b> na jaki możemy umówić spotkanie <br/>
                to: 
                <DatePicker
                    selected={currentDate} 
                    onChange={(date) => handleCurrentDate(date)}
                    minDate={startDate}
                    open={true}
                    inline
                    locale={locale}
                    calendarStartDay={1}
                    calendarContainer={MyContainer}
                    onMonthChange={handleMonthChange} 
                />
            </div>
        )
    }
}

class FormSent extends React.Component {
    render() {
        const {data, message, lawyer, ifSent, errors} = this.props
        const {created} = data || ''
        const {title, user} = lawyer || ''
        const {name} = title || ''
        const {first_name} = user || ''
        
        return(
            <div className='col-sm-6 respondFormContainer'>
                <h1 className="stdHeader text-primary">Twoja odpowiedź</h1>
                <div className="from">
                    Od: {name} <b>{first_name}</b>
                </div>
                <InputResults data={data} ifSent={ifSent}/>
                <ChatBox message={message} lawyer={lawyer} created={created}/>
                <Errors errors={errors} />
                </div>
        )
    }
}

class InputResults extends React.Component {
    render() {
        const {data, ifSent} = this.props
        const {rate_per_hour, discount,earliest_available_date} = data
        let date='';
        
        if (earliest_available_date) {
            date = new Date(Date.parse(earliest_available_date + 'EDT')).toISOString()
        } else {
            date = new Date().toISOString();
        }
        let weekday = getWeekday(new Date(date).getDay())
        let datephrase = datePhrase(String((date)).slice(0,10).split('-').reverse().join('.'))
        return(
            <div>
                Chętnie udzielimy Państwu <b>pomocy</b>.<br/>
                <div className="form-group">
                    Nasza <b>stawka za godzinę</b> wynosi {rate_per_hour} złotych + 23% VAT <br/>
                </div>
                <CasePrice data={data} ifSent={ifSent}/>
                <div className="form-group">
                    Nowym klientom z serwisu&nbsp; 
                    <a href="/" className="text-primary">SpecPrawnik.pl </a>
                    oferujemy przy pierwszej wizycie <b>rabat w wysokości</b> {discount} %
                </div>
                <div className="preLast form-group">
                    <b>Najwcześniejszy termin </b> na jaki możemy umówić spotkanie, <br/>
                    to: <b>{weekday}, {datephrase}</b>
                </div>
                <div>
                    Aby ustalić dokładną godzinę spotkania, <b>prosimy o kontakt</b> z naszą kancelarią
                </div>
            </div>
        )
    }
}

class ChatBox extends React.Component {
    render() {
        const {message, created, lawyer} = this.props
        const {photo_url, title, user} = lawyer
        const {name} = title || ''
        const {first_name} = user || ''
        let datephrase = datePhrase(created.slice(0,10))
        let time = created.slice(11, 17)
        if (message)
        return(
            <div className="chat-respond">
                <hr />
                <div className="chat-lawyer">
                    <img src={photo_url} className="chat-img" alt='zdjęcie profilowe prawnika'></img>
                    <div className="chat-title">
                        <span className="text-primary">{name} {first_name}</span>
                        <span className="text-date">
                            Wysłano dnia {datephrase} o godz. {time}
                        </span>
                    </div>
                </div>
                <span className="message">{message}</span>
                <hr />
            </div>
        )
    }
}

class CasePrice extends React.Component {
    render() {
        const {ifSent, handleDataChange, data} = this.props
        let {or_per_case, case_cost} = data
        if (!case_cost) {
            case_cost = ''
        }
        if (or_per_case) {
            if(!ifSent) {
                return (
                    <div className="form-group">
                        <label htmlFor="case_cost" className="inline">Wysokość opłaty za podaną sprawę:</label>
                        <input 
                            id="case_cost" 
                            type="text" 
                            name="case_cost" 
                            className="small input" 
                            size="7" min="0" 
                            onChange={(case_cost)=>handleDataChange(case_cost)} 
                            value={case_cost}
                        />
                        złotych + 23% VAT
                    </div>
                )
            } else {
                return (
                    <div className="form-group">
                        Oferujemy również opłaty całościowe "od sprawy" w wysokości {case_cost} złotych + 23% VAT
                    </div>
                )
            }
    };   
}
}

export default RespondForm;